import { ref, remove, serverTimestamp, set, update } from "firebase/database";
import {
  deleteObject,
  // getDownloadURL,
  ref as sRef,
  uploadBytes,
} from "firebase/storage";
import firebaseInit from "../../firebase";
import {
  DebPath,
  SetPathToFile,
  StoragePath,
} from "../../helpers/fileUploader/pathHandlers";
import axios from "axios";
import Cookies from "js-cookie";
import { RemoveFileExt } from "../../utilities/utilityService";
import {
  C_GENERAL,
  C_LEGAL_DOCUMENTS,
  C_TRADING_HOURS,
} from "../../constants/types";
import { logActivity } from "./activityLog";

const database = firebaseInit.database;
const storage = firebaseInit.storage;

export const checkRef = (database, path) => {
  try {
    ref(database, path);
    if (/%/g.test(path)) {
      throw new Error("filename can't contain '%'");
    }
    return true;
  } catch (error) {
    if (error.message.includes("path argument was an invalid path")) {
      return "filename must be non-empty strings and can't contain '.', '#', '$', '[', or ']'";
    } else {
      return error.message;
    }
  }
};

//write data to rtdb
export const WriteUserData = (
  fileName,
  category,
  userId,
  setIsLoading,
  setResponse,
  formRef,
  subCategory,
  handleApi,
  selectedFile,
  setFileName,
  setSelectedFile,
  setError,
) => {
  var parse = RemoveFileExt(fileName);
  let path = DebPath(category, subCategory, parse);
  let filePath = SetPathToFile(category, subCategory, parse, fileName);

  if (checkRef(database, path) === true) {
    set(ref(database, path), {
      user_id: userId,
      file_name: fileName,
      category: category,
      file: filePath,
      createdAt: serverTimestamp(),
    })
      .then(() => {
        if (
          category === C_GENERAL ||
          category === C_LEGAL_DOCUMENTS ||
          category === C_TRADING_HOURS
        ) {
          update(ref(database, `category/${category}`), {
            createdAt: serverTimestamp(),
          });
        }
        setIsLoading(false);
        console.log("Data saved successfully!");
        //log
        logActivity({
          category: "write_rtdb",
          event: "file_write_success",
          email: userId,
          metadata: { file_name: fileName },
          message: "File upload - write to db success",
        });
        //upload file to storage
        UploadToStorage(
          fileName,
          selectedFile,
          category,
          subCategory,
          parse,
          setFileName,
          setSelectedFile,
          userId,
        );
        setResponse("write_rtdb", true);
        formRef.current.reset();
        handleApi();
        return true;
      })
      .catch((error) => {
        setIsLoading(false);
        setResponse("write_rtdb", false);
        //log
        logActivity({
          category: "write_rtdb",
          event: "file_write_fail",
          email: userId,
          metadata: { file_name: fileName },
          message: "File upload - write to db success",
        });
        console.log("The write failed...", error);
      });
  } else {
    setIsLoading(false);
    setResponse("write_rtdb", false);
    setError(checkRef(database, path));
  }
};

//upload file to storage
export const UploadToStorage = async (
  fileName,
  selectedFile,
  category,
  subCategory,
  parse,
  setFileName,
  setSelectedFile,
  userId,
) => {
  let filePath = StoragePath(category, subCategory, parse, fileName);

  try {
    await uploadBytes(sRef(storage, filePath), selectedFile);
    console.log("Uploaded successfully!");
    setFileName("");
    setSelectedFile(null);

    // const downloadURL = await getDownloadURL(sRef(storage, filePath));
     const publicURL = `https://gom.digital/files/${filePath
       .split("/")
       .map(encodeURIComponent)
       .join("/")}`;

    //log
    logActivity({
      category: "storage_upload",
      event: "file_upload_success",
      email: userId,
      metadata: { file_name: fileName },
      message: "File upload - store success",
    });
    // return downloadURL;
    return publicURL;
  } catch (error) {
    console.log("Upload failed...");
    //log
    logActivity({
      category: "storage_upload",
      event: "file_upload_fail",
      email: userId,
      metadata: { file_name: fileName },
      message: `File upload - store fail - ${error}`,
    });
  }
};

export const Delete = (value, subCategory, handleApi) => {
  var parse = RemoveFileExt(value.file_name);
  let path = DebPath(value.category, subCategory, parse);
  let file = StoragePath(value.category, subCategory, parse, value.file_name);

  remove(ref(database, path))
    .then(() => {
      handleApi();
      deleteObject(sRef(storage, file))
        .then(() => {
          console.log("removed successfully - storage");
          //log
          logActivity({
            category: "storage_delete",
            event: "file_delete_success",
            email: value.user_id,
            metadata: { file_name: value.file_name },
            message: "File delete - storage success",
          });
        })
        .catch((error) => {
          console.error(error);
          //log
          logActivity({
            category: "storage_delete",
            event: "file_delete_failed",
            email: value.user_id,
            metadata: { file_name: value.file_name },
            message: `File delete - storage failed - ${error}`,
          });
        });
      console.log("removed successfully - db");
      //log
      logActivity({
        category: "db_delete",
        event: "db_delete_success",
        email: value.user_id,
        metadata: { file_name: value.file_name },
        message: "File delete - db success",
      });
    })
    .catch((error) => {
      console.error(error);
      //log
      logActivity({
        category: "db_delete",
        event: "db_delete_failed",
        email: value.user_id,
        metadata: { file_name: value.file_name },
        message: `File delete - db failed - ${error}`,
      });
    });
};

export const GetUploads = async () => {
  return await axios
    .get(
      `https://go-marketing-apps-default-rtdb.firebaseio.com/category.json?auth=${Cookies.get(
        "token",
      )}`,
    )
    .then((res) => {
      if (res.data) {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const UpdateData = async (
  historyItem,
  subCategory,
  userId,
  selectedFile,
  setIsLoading,
  setRes,
) => {
  try {
    setIsLoading(true);
    const category = historyItem.category;
    const fileName = historyItem.file_name;
    const parse = RemoveFileExt(fileName);

    const dbPath = DebPath(category, subCategory, parse);
    const storagePath = StoragePath(category, subCategory, parse, fileName);

    //Replace file in Storage (automatic overwrite)
    if (selectedFile) {
      await uploadBytes(sRef(storage, storagePath), selectedFile);
    }

    //Update DB metadata
    await update(ref(database, dbPath), {
      user_id: userId,
      createdAt: serverTimestamp(),
    });

    setIsLoading(false);
    setRes({ msg: "File updated successfully", type: "success" });
    console.log("File updated successfully");
  } catch (error) {
    console.error("Update failed", error);
    setIsLoading(false);
    setRes({ msg: error.message || "Update failed", type: "error" });
  }
};
